import React, { useState, useEffect } from "react";
import {
  DialogContent,
  TextField,
  Button,
  Grid,
  Typography,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ErrorMessage from "src/pages/RegistrationForm/forms/ErrorMessage.jsx";
import { loginNetworkCall, loginWithOtpEmail } from "src/Api/auths.js";
import { useSnackbar } from "notistack5";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import RetryPopup from "src/components/popup/RetryPopup.jsx";
// import ThankyouPopup from "../thankyoupopup/ThankyouPopup";

export const AuthLogin = ({
  onForgot,
  onGetPassword,
  onStepChange,
  handleClose,
  onGetEmail,
  onGetFlowId,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [form, setForm] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(true);
  const [retryPopup, setRetryPopup] = useState({ open: false, message: "" });
  const [isLoadingOtpEmail, setIsLoadingOtpEmail] = useState(false);
  const [isOtpMode, setIsOtpMode] = useState(true);
  const [prevFlowId, setPrevFlowId] = useState(null);

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error on change
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.username) {
      newErrors.username = "Username is required";
    }

    if (!form.password) {
      newErrors.password = "Password is required";
    } else if (form.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }

    return newErrors;
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    const getLocalDeviceId = localStorage.getItem("deviceId");

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitted(false);
    } else {
      setErrors({});
      setSubmitted(true);
      setIsLoadingLogin(true);
      const response = await loginNetworkCall({
        ...form,
        deviceId: getLocalDeviceId,
        ...(prevFlowId && { prevFlowId }),
      });
      setIsLoadingLogin(false);

      if (response.status) {
        enqueueSnackbar(response.message, {
          variant: "success",
          onClick: (event, key) => {
            closeSnackbar(key); // Dismiss notification on tap
          },
        });

        setPrevFlowId(null);
        onForgot();
        onGetEmail(form.username);
        onGetPassword(form.password);
        onGetFlowId(response.flowId);
        onStepChange(2);
      } else {
        if (response.flowId) {
          setPrevFlowId(response.flowId);
        }
        setRetryPopup({ open: true, message: response.message });
        // enqueueSnackbar(response.message, {
        //   variant: "error",
        //   onClick: (event, key) => {
        //     closeSnackbar(key); // Dismiss notification on tap
        //   },
        // });
      }
    }
  };

  const handleLoginWithOtpEmail = async () => {
    if (!form.username) {
      setErrors({ ...errors, username: "Please enter your email to login with OTP" });
      return;
    }
    setIsLoadingOtpEmail(true);
    const response = await loginWithOtpEmail({ email: form.username });
    setIsLoadingOtpEmail(false);
    if (response?.status) {
      enqueueSnackbar(response.message || "OTP sent to your email", {
        variant: "success",
        onClick: (event, key) => { closeSnackbar(key); },
      });
      onGetEmail(form.username);
      onGetFlowId(response.flowId);
      onStepChange(2);
    } else {
      enqueueSnackbar(response?.message || "Failed to send OTP. Please try again.", {
        variant: "error",
        onClick: (event, key) => { closeSnackbar(key); },
      });
    }
  };

  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <RetryPopup
        open={retryPopup?.open}
        errorMessage={retryPopup?.message}
        onClose={() => setRetryPopup({ open: false, message: "" })}
      />
      <DialogContent sx={{ padding: 0, display: "flex" }}>
        <Grid
          item
          xs={4}
          sx={{
            backgroundColor: "#8B0203",
            padding: "20px",
            display: "flex",
            flexBasis: "50%",
            flexDirection: "column",
            justifyContent: "center",
            color: "white",
            textAlign: "left",
            overflow: "auto",
            paddingBottom: "0px",
          }}
        >
          <h2 className="text-[26px] font-[700] leading-[36px] mb-[1rem] mt-[2rem]">
            {" "}
            Sign In
          </h2>
          <h3 className="text-[16px] font-[600] mb-[1rem]">
            Please enter your account details.
          </h3>
          <div className="mt-2 w-full">
            <Slider {...settings}>
              {images.map((img, index) => (
                <div key={index}>
                  <img
                    src={img}
                    alt="Flight deals"
                    className="rounded-lg inline-block mb-3 h-[302px] object-cover w-full"
                    style={{
                      clipPath:
                        "polygon(48% 0, 100% 0, 100% 90%, 88% 100%, 0 99%, 0 0)",
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </Grid>

        {/* Right Side - White Form */}
        <Grid item xs={7} sx={{ padding: "20px", position: "relative" }}>
          <form onSubmit={isOtpMode ? (e) => { e.preventDefault(); handleLoginWithOtpEmail(); } : handleLoginSubmit}>
            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: "10px",
                top: "10px",
              }}
            >
              <CloseIcon />
            </IconButton>

            <div className="flex justify-center items-center mt-[3rem] mb-[2rem]  w-[280px]">
              <Tabs
                value={tabValue}
                onChange={handleChange}
                className="mb-6"
                sx={{
                  width: "auto",
                  display: "inline-flex",
                  background: "#FFFFFF26",
                  borderRadius: "25px",
                  padding: "5px",
                  border: "1px solid #FF898A",
                  boxShadow: "0px 0px 10px 0px #0000000F;",
                  maxWidth: "700px",
                  margin: "0 auto",
                  "& .MuiTabs-indicator": { display: "none" },
                }}
              >
                <Tab
                  icon={
                    // <img
                    //   src="/image/home/advertising.svg"
                    //   alt="Agency"
                    //   style={{
                    //     width: "20px",
                    //     height: "20px",
                    //     marginRight: "8px",
                    //   }}
                    // />
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1741_332)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.7099 3.46082C13.6742 3.32742 13.606 3.20497 13.5113 3.10447C13.4166 3.00396 13.2985 2.92856 13.1674 2.88504L13.5279 4.23057C13.6196 4.12737 13.6842 4.00301 13.716 3.86865C13.7477 3.7343 13.7456 3.59415 13.7098 3.46082H13.7099ZM8.92862 10.1115C8.07162 9.95469 7.23965 9.65391 6.58546 9.41741C5.63624 9.07426 5.3818 8.99513 4.44605 9.53688L2.69918 10.5483L4.11612 13.0519L4.30649 12.942C4.36348 12.9089 4.43126 12.8998 4.49496 12.9166L8.25234 13.9234C8.8059 14.0718 9.12352 13.9747 9.61287 13.7249L14.7754 10.546C15.0395 10.3835 15.074 9.93979 14.9174 9.68744C14.5729 9.13232 13.6211 9.5926 13.2242 9.82376L10.3696 11.4863C10.1542 11.6133 9.91733 11.6999 9.67074 11.7417C8.9694 11.8595 7.90443 11.5257 7.27793 11.3468C7.07452 11.2887 6.86802 11.2297 6.66496 11.1753C6.60099 11.1582 6.54643 11.1164 6.51328 11.0591C6.48013 11.0017 6.47112 10.9336 6.48821 10.8696C6.5053 10.8057 6.54711 10.7511 6.60443 10.718C6.66175 10.6848 6.7299 10.6758 6.79387 10.6929C7.41137 10.8583 8.02337 11.0572 8.6494 11.1866C8.96896 11.2258 9.2328 11.1244 9.32146 10.7935C9.40193 10.4931 9.21187 10.2096 8.92859 10.1115L8.92862 10.1115ZM1.90287 10.1565L4.17046 14.1632C4.22302 14.2567 4.23644 14.3671 4.2078 14.4705C4.17915 14.5738 4.11077 14.6617 4.01759 14.7148L3.24627 15.1513C3.15279 15.2038 3.0423 15.2173 2.93894 15.1886C2.83559 15.16 2.74777 15.0916 2.69468 14.9984L0.427054 10.9917C0.374514 10.8982 0.361105 10.7877 0.389754 10.6844C0.418403 10.581 0.486783 10.4932 0.57996 10.4401L1.35127 10.0036C1.44476 9.95105 1.55525 9.93763 1.6586 9.96628C1.76195 9.99492 1.84977 10.0633 1.90287 10.1565ZM1.3829 10.7571C1.32901 10.7649 1.27866 10.7886 1.23823 10.8251C1.1978 10.8616 1.16909 10.9093 1.15575 10.9621C1.1424 11.0149 1.14502 11.0705 1.16326 11.1218C1.1815 11.1731 1.21454 11.2178 1.25822 11.2504C1.3019 11.2829 1.35424 11.3018 1.40863 11.3046C1.46302 11.3074 1.51702 11.2939 1.5638 11.266C1.61057 11.2381 1.64802 11.197 1.67141 11.1478C1.6948 11.0986 1.70309 11.0436 1.69521 10.9897C1.68998 10.9539 1.67775 10.9195 1.65923 10.8885C1.6407 10.8574 1.61624 10.8303 1.58724 10.8087C1.55824 10.7871 1.52527 10.7714 1.4902 10.7626C1.45514 10.7537 1.41868 10.7518 1.3829 10.7571ZM14.4318 4.89566C14.4035 4.87925 14.3787 4.85741 14.3588 4.8314C14.3389 4.80539 14.3243 4.77571 14.3158 4.74406C14.3074 4.71241 14.3053 4.67941 14.3096 4.64694C14.3139 4.61448 14.3246 4.58318 14.341 4.55484C14.3574 4.52649 14.3793 4.50166 14.4053 4.48176C14.4313 4.46185 14.461 4.44727 14.4926 4.43883C14.5243 4.4304 14.5573 4.42828 14.5897 4.4326C14.6222 4.43692 14.6535 4.44759 14.6818 4.46401L15.1916 4.75835C15.2489 4.7915 15.2906 4.84604 15.3076 4.90995C15.3247 4.97387 15.3156 5.04194 15.2824 5.09918C15.266 5.12752 15.2442 5.15235 15.2182 5.17226C15.1922 5.19216 15.1625 5.20675 15.1308 5.21518C15.0669 5.23221 14.9989 5.22316 14.9416 5.19001L14.4318 4.89566ZM14.8707 3.40816C14.8069 3.42472 14.7392 3.41539 14.6822 3.38219C14.6253 3.34899 14.5838 3.29462 14.5667 3.23094C14.5497 3.16726 14.5586 3.09944 14.5914 3.04226C14.6242 2.98508 14.6782 2.94319 14.7418 2.92573L15.3106 2.77338C15.3422 2.76492 15.3753 2.76278 15.4078 2.76708C15.4403 2.77138 15.4716 2.78204 15.5 2.79845C15.5284 2.81487 15.5532 2.83671 15.5732 2.86273C15.5931 2.88876 15.6077 2.91846 15.6162 2.95013C15.6247 2.98181 15.6268 3.01484 15.6225 3.04734C15.6182 3.07985 15.6076 3.11118 15.5911 3.13957C15.5747 3.16795 15.5529 3.19282 15.5269 3.21276C15.5008 3.2327 15.4711 3.24732 15.4395 3.25579L14.8707 3.40816ZM13.9685 1.30482C14.0014 1.24758 14.0557 1.20575 14.1194 1.18853C14.1831 1.17131 14.2511 1.18012 14.3083 1.21301C14.3656 1.2459 14.4074 1.30018 14.4246 1.36391C14.4418 1.42765 14.433 1.49561 14.4001 1.55285L14.1058 2.06266C14.0729 2.1199 14.0186 2.16173 13.9549 2.17894C13.8912 2.19615 13.8232 2.18734 13.766 2.15444C13.7087 2.12155 13.6669 2.06726 13.6497 2.00353C13.6325 1.9398 13.6413 1.87184 13.6742 1.8146L13.9685 1.30482ZM8.52543 3.36941L7.09252 3.75335C6.91289 3.80082 6.74439 3.88329 6.5967 3.99601C6.449 4.10874 6.32501 4.24952 6.23183 4.41026C6.13865 4.57101 6.07812 4.74857 6.05371 4.93276C6.0293 5.11695 6.04149 5.30415 6.08957 5.48362C6.13766 5.66309 6.2207 5.8313 6.33394 5.97861C6.44717 6.12592 6.58837 6.24943 6.74944 6.34206C6.9105 6.43468 7.08827 6.4946 7.27254 6.51838C7.45681 6.54216 7.64397 6.52933 7.82327 6.48063L9.25618 6.09669L8.52543 3.36941ZM8.9749 3.11498C9.66284 2.68191 10.2779 2.09816 10.838 1.54169L12.1505 6.43948C11.3837 6.22726 10.5894 6.06519 9.76705 6.07088L8.9749 3.11491V3.11498ZM11.2459 1.13463C11.3188 1.06192 11.3909 0.990695 11.4621 0.920945C11.5157 0.868638 11.5819 0.831251 11.6544 0.812501C11.7268 0.793752 11.8029 0.794294 11.8751 0.814072C11.9473 0.833851 12.013 0.872178 12.0658 0.925241C12.1185 0.978305 12.1565 1.04426 12.1759 1.11654L13.5296 6.16891C13.5495 6.24304 13.5491 6.32113 13.5285 6.39505C13.5079 6.46897 13.4678 6.53599 13.4124 6.58913C13.357 6.64227 13.2884 6.67957 13.2137 6.69715C13.139 6.71472 13.061 6.71192 12.9877 6.68904C12.8961 6.66035 12.8039 6.63186 12.7113 6.60357L11.2459 1.13457V1.13463ZM9.92296 8.58504L9.66065 8.65532C9.46194 8.70811 9.25042 8.68002 9.07237 8.57721C8.89432 8.4744 8.76426 8.30524 8.71065 8.10676L8.37409 6.85051L9.34443 6.59051C9.35887 6.58923 9.3733 6.5881 9.38774 6.58694L9.92296 8.58504Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1741_332">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  iconPosition="start"
                  label="Agency"
                  sx={{
                    background: tabValue === 0 ? "#CB2B2C" : "transparent",
                    color: tabValue === 0 ? "#fff !important" : "#272727",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    padding: "5px 20px",
                    minHeight: "40px",
                    transition: "0.3s",
                    margin: "0px !important",
                  }}
                />
                {/* <Tab
                  icon={
                    <img
                    src="/Image/home/corporate.svg"
                    alt="Corporate"
                    style={{
                      width: "20px",
                        height: "20px",
                        marginRight: "8px",
                        }}
                        />
                        }
                        iconPosition="start"
                        label="Corporate"
                        sx={{
                          background: tabValue === 1 ? "#CB2B2C" : "transparent",
                          color: tabValue === 1 ? "#fff !important" : "#272727",
                          borderRadius: "20px",
                          fontWeight: "bold",
                          padding: "10px 20px",
                          minHeight: "40px",
                          transition: "0.3s",
                          margin: "0px !important",
                          }}
                          /> */}

                {/* <Tab
                  icon={
                    <img
                    src="/image/home/corporate.svg"
                    alt="Developers"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "8px",
                      }}
                      />
                      }
                      iconPosition="start"
                      label="Developers"
                      sx={{
                        background: tabValue === 2 ? "#CB2B2C" : "transparent",
                        color: tabValue === 2 ? "#fff !important" : "#272727",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        minHeight: "40px",
                        transition: "0.3s",
                        }}
                        />
                        */}
              </Tabs>
            </div>

            <div className="w-full relative">
              <TextField
                fullWidth
                value={form.username}
                onChange={handleInputChange}
                name="username"
                size="small"
                placeholder={isOtpMode ? "Enter Your Email*" : "Username or Email*"}
                variant="outlined"
                sx={{
                  marginTop: "10px",
                  width: "100%",
                  "& .MuiInputBase-input": {
                    padding: "15px",
                  },
                }}
              />
              <ErrorMessage
                className="bottom-[-24px]"
                isError={errors?.username}
                message={errors?.username}
              />
            </div>

            {/* Password field — hidden in OTP mode */}
            {!isOtpMode && (
            <div className="w-full relative">
              <TextField
                fullWidth
                value={form.password}
                name="password"
                type={!showPassword ? "text" : "password"}
                onChange={handleInputChange}
                size="small"
                placeholder="Password*"
                variant="outlined"
                sx={{
                  marginTop: "10px",
                  width: "100%",
                  "& .MuiInputBase-input": {
                    padding: "15px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((p) => !p)}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff sx={{ padding: 0 }} />
                        ) : (
                          <Visibility sx={{ padding: 0 }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <ErrorMessage
                className="bottom-[-24px]"
                isError={errors?.password}
                message={errors?.password}
              />
            </div>
            )}
            <div className="flex justify-between items-center mt-2 ">
              {isOtpMode ? (
                // OTP mode (default) — show "use password" + forgot password
                <>
                  <Button
                    onClick={() => onStepChange(1)}
                    className="p-0 !bg-white !text-[12px] !font-[500] !text-[#272727]"
                  >
                    Forgot Password?
                  </Button>
                  <Button
                    onClick={() => { setIsOtpMode(false); setErrors({}); }}
                    className="p-0 !bg-white !text-[12px] !font-[600] !text-[#CB2B2C] !lowercase"
                  >
                    <span className="!uppercase">L</span>ogin with Password
                  </Button>
                </>
              ) : (
                // Password mode — show forgot + switch back to OTP
                <>
                  <Button
                    onClick={() => onStepChange(1)}
                    className="p-0 !bg-white !text-[12px] !font-[500] !text-[#272727]"
                  >
                    Forgot Password?
                  </Button>
                  <Button
                    onClick={() => { setIsOtpMode(true); setErrors({}); }}
                    className="p-0 !bg-white !text-[12px] !font-[600] !text-[#CB2B2C] !lowercase"
                  >
                    <span className="!uppercase">L</span>ogin with Email OTP
                  </Button>
                </>
              )}
            </div>

            {/* --------------------------------------MOBILE---------------------------- */}
            <div className="flex mt-[5px] items-center">
              <div className="mt-[5px] basis-[30%]">
                {/* <CountrySelect
          selectedCountry={countryInfo}
          setSelectedCountry={setCountryInfo}
          name={"countryCode"} /> */}
              </div>
            </div>

            <Typography
              variant="caption"
              sx={{
                marginTop: "2rem",
                fontSize: "12px",
                fontWeight: "500",
                display: "block",
                textAlign: "center",
                color: "#272727",
              }}
            >
              Didn’t have an account?{" "}
              <Link
                to={"/registration-form"}
                onClick={handleClose}
                // href="/registration-form"
                className="p-0 no-underline text-[#CB2B2C] font-[600]"
              >
                Register Now
              </Link>
            </Typography>

            <Button
              disabled={isOtpMode ? isLoadingOtpEmail : isLoadingLogin}
              variant="contained"
              fullWidth
              type="submit"
              sx={{
                backgroundColor: "#CB2B2C",
                color: "white",
                fontWeight: "bold",
                marginTop: "15px",
                "&:hover": { backgroundColor: "#A00000" },
              }}
            >
              {isOtpMode
                ? isLoadingOtpEmail ? "Sending OTP..." : "Send OTP"
                : "Submit"}
            </Button>
          </form>
        </Grid>
      </DialogContent>
    </>
  );
};

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
};
const images = [
  "/Image/home/partner_back_img_1.webp",
  "/Image/home/partner_back_img_2.webp",
  "/Image/home/partner_back_img_3.webp",
];
